import { useEffect, useState } from "react";

export default function FloatButtons() {
  const [visible, setVisible] = useState(false);

  // 300px scroll ke baad buttons dikhenge
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* ========== WHATSAPP FLOAT BUTTON ========== */}
      <a
        href="https://wa.me/917000191398?text=Hi%20SDtech%20Solutions%2C%20I%20have%20a%20project%20in%20mind.%20Can%20we%20discuss%3F"
        target="_blank"
        rel="noreferrer"
        className="whatsapp-float"
        style={{
          position: "fixed",
          bottom: "70px",
          right: "10px",
          width: "55px",
          height: "55px",
          backgroundColor: "#25D366",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontSize: "28px",
          zIndex: 9999,
          boxShadow: "0 5px 20px rgba(37, 211, 102, 0.4)",
          transition: "all 0.3s ease",
          textDecoration: "none",
          opacity: visible ? 1 : 0,
          transform: visible ? "scale(1)" : "scale(0.5)",
          pointerEvents: visible ? "auto" : "none",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.15)";
          e.currentTarget.style.boxShadow = "0 8px 30px rgba(37, 211, 102, 0.6)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow = "0 5px 20px rgba(37, 211, 102, 0.4)";
        }}
        title="Chat on WhatsApp"
      >
        <i className="bi bi-whatsapp" />
      </a>

      {/* ========== TOOLTIP (WhatsApp) ========== */}
      <div
    
      >
        {/* 💬 Chat with Us */}
        <div
          style={{
            position: "absolute",
            bottom: "-6px",
            right: "25px",
            width: 0,
            height: 0,
            borderLeft: "6px solid transparent",
            borderRight: "6px solid transparent",
            borderTop: "6px solid #333",
          }}
        />
      </div>

      {/* ========== CALL FLOAT BUTTON ========== */}
      <a
        href="tel:+917000191398"
        className="call-float"
        style={{
          position: "fixed",
          bottom: "140px",
          right: "10px",
          width: "55px",
          height: "55px",
          backgroundColor: "#007bff",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontSize: "24px",
          zIndex: 9999,
          boxShadow: "0 5px 20px rgba(0, 123, 255, 0.4)",
          transition: "all 0.3s ease",
          textDecoration: "none",
          opacity: visible ? 1 : 0,
          transform: visible ? "scale(1)" : "scale(0.5)",
          pointerEvents: visible ? "auto" : "none",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.15)";
          e.currentTarget.style.boxShadow = "0 8px 30px rgba(0, 123, 255, 0.6)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow = "0 5px 20px rgba(0, 123, 255, 0.4)";
        }}
        // title="Call Us Now"
      >
        <i className="bi bi-telephone-fill" />
      </a>

      {/* ========== TOOLTIP (Call) ========== */}
      <div
    
      >
        
        <div
          style={{
            position: "absolute",
            bottom: "-6px",
            right: "25px",
            width: 0,
            height: 0,
            borderLeft: "6px solid transparent",
            borderRight: "6px solid transparent",
            borderTop: "6px solid #333",
          }}
        />
      </div>

      {/* ========== PULSE ANIMATION CSS ========== */}
      <style>
        {`
          @keyframes pulse-green {
            0% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.5); }
            70% { box-shadow: 0 0 0 15px rgba(37, 211, 102, 0); }
            100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0); }
          }
          @keyframes pulse-blue {
            0% { box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.5); }
            70% { box-shadow: 0 0 0 15px rgba(0, 123, 255, 0); }
            100% { box-shadow: 0 0 0 0 rgba(0, 123, 255, 0); }
          }
          .whatsapp-float {
            animation: pulse-green 2s infinite;
          }
          .call-float {
            animation: pulse-blue 2s infinite;
          }
          .whatsapp-float:hover,
          .call-float:hover {
            animation: none;
          }

          /* Mobile Responsive */
          @media (max-width: 576px) {
            .whatsapp-float,
            .call-float {
              width: 50px !important;
              height: 50px !important;
              font-size: 22px !important;
            }
          }
        `}
      </style>
    </>
  );
}